import { createSelector } from 'reselect'
import { TaxonomyElement } from '../api/models/TaxonomyElement';
import { OrderItem } from '../api/models/OrderData';
import { OrderSheetItemData, OrderSheetData } from '../api/models/OrderSheetData';

const getLeafs = function (item: TaxonomyElement): TaxonomyElement[] {
    let leafs: TaxonomyElement[] = []
    if (item.subcategories.length === 0)
        leafs.push(item)
    else
        for (let i: number = 0; i < item.subcategories.length; i++)
            leafs = leafs.concat(getLeafs(item.subcategories[i]))

    return leafs
}

export const itemsSelector = createSelector((items: TaxonomyElement | null) => items,
    (items): TaxonomyElement[] => {
        if (items) {
            return getLeafs(items);
        }
        else
            return [];
    });

export const toProductsList = createSelector((suggested: TaxonomyElement[]) => suggested,
    (suggested): OrderSheetItemData[] => {
        let products: OrderSheetItemData[] = []

        for (let i = 0; i < suggested.length; i++)
            products.push(new OrderSheetItemData( 
                suggested[i].id, 
                0,
                suggested[i].units[0],
                suggested[i].units, 
                suggested[i]._availableProperties, 
                suggested[i]._selectedProperties || [],
                suggested[i].properties,
                suggested[i].name, 
                suggested[i].image))

            return products
    })


export const toOrderItems = (orderSheet: OrderSheetData) => {
    let orderItems: OrderItem[] = []
    for (let osi of orderSheet.items)
        if(osi.quantity !== null)
            orderItems.push({ catalogueProductId: osi.catalogueProductId, unit: osi.unit.id, quantity: osi.quantity, selectedProperties: osi.selectedProperties})

    return orderItems
}